var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "2 2 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19.575,8.833c-1.119-2.666-3.605-4.615-6.576-4.978v6.74L19.575,8.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19.59,15.127c0.399-0.965,0.622-2.02,0.622-3.127c0-0.422-0.042-0.834-0.104-1.24l-5.519,1.479L19.59,15.127z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10.999,12.771V3.855C6.941,4.351,3.787,7.812,3.787,12c0,4.529,3.684,8.213,8.212,8.213 c2.707,0,5.104-1.321,6.602-3.348l-7.091-4.094H10.999z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.999,10.596 12.141,10.825 12.999,11.321  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.441,11.013 11.58,11.532 11.96,10.874  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.999,12.771 12.999,12.666 12.607,12.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.58,11.532 11.526,11.626 11.62,11.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.026,10.76 11.96,10.874 12.141,10.825  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.959,12.945 12.607,12.771 11.912,12.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.365,11.532 12.999,11.321 12.999,11.631  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.999,12.666 13.224,12.606 12.999,12.476  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999,1.788C6.368,1.788,1.787,6.369,1.787,12c0,5.632,4.581,10.213,10.212,10.213c5.632,0,10.213-4.581,10.213-10.213 C22.212,6.369,17.631,1.788,11.999,1.788z M19.575,8.833l-6.576,1.763v-6.74C15.97,4.218,18.456,6.167,19.575,8.833z  M11.999,20.213c-4.528,0-8.212-3.684-8.212-8.213c0-4.188,3.154-7.649,7.212-8.145l0.011,8.682l0.5,0.234l7.091,4.094 C17.104,18.892,14.706,20.213,11.999,20.213z M14.59,12.239l5.519-1.479c0.062,0.406,0.104,0.818,0.104,1.24 c0,1.107-0.223,2.162-0.622,3.127L14.59,12.239z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.149,16.027 20.066,16.557 19.149,16.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.62,11.68 11.526,11.626 11.62,11.68  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.111,
    y: 12.411,
    width: 0,
    height: 0.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.922,
    y: 12.187,
    transform: "matrix(-0.8661 -0.4999 0.4999 -0.8661 17.2325 28.9901)",
    width: 1.155,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.81,
    y: 11.57,
    width: 0,
    height: 0.438
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPieChart);
export default __webpack_public_path__ + "static/media/iconPieChart.4f201351c432964d0ad2636cb4f8d728.svg";
export { ForwardRef as ReactComponent };